import React from "react";
import { Link } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";

import Close from "mdi-material-ui/Close";

import themeConfig from "configs/themeConfig";
import LogoImage from "assets/images/logo/ksijLogo.svg";

const MenuHeaderWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  paddingRight: theme.spacing(4),
  justifyContent: "space-between",
  transition: "padding .25s ease-in-out",
  minHeight: theme.mixins.toolbar.minHeight,
}));

// const Img = styled("img")(({ theme }) => ({
//   [theme.breakpoints.up("md")]: {
//     marginRight: theme.spacing(1),
//   },
//   [theme.breakpoints.down("md")]: {
//     marginBottom: theme.spacing(2),
//   },
//   [theme.breakpoints.down("sm")]: {
//     width: 40,
//     height: 40,
//   },
//   marginBottom: theme.spacing(2),
// }));

const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  lineHeight: 1.2,
  transition: "opacity .25s ease-in-out, margin .25s ease-in-out",
  margin: "0 1rem",
});

const SideMenuHeader = (props) => {
  const {
    toggleNavVisibility,
    navHover,
    navigationBorderWidth,
    collapsedNavWidth,
    hidden,
    settings,
    saveSettings,
  } = props;
  const theme = useTheme();

  const { navCollapsed } = settings;

  const svgRotationDeg = () => {
    if (navCollapsed) {
      if (navHover) {
        return 180;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  };

  const menuHeaderPaddingLeft = () => {
    if (navCollapsed && !navHover) {
      return (collapsedNavWidth - navigationBorderWidth - 40) / 8;
    } else {
      return 5.5;
    }
  };

  const menuCollapsedStyles =
    navCollapsed && !navHover ? { opacity: 0 } : { opacity: 1 };

  return (
    <MenuHeaderWrapper
      className="nav-header"
      sx={{ pl: menuHeaderPaddingLeft() }}
    >
      <Link
        to={"/announcement"}
        style={{
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <Avatar
          alt="Img"
          sx={{ width: 45, height: 45 }}
          src={LogoImage}
        />

        <HeaderTitle
          variant="h6"
          sx={{
            ...menuCollapsedStyles,
          }}
        >
          {themeConfig.templateName}
        </HeaderTitle>
      </Link>
      {hidden ? (
        <IconButton
          disableRipple
          disableFocusRipple
          onClick={toggleNavVisibility}
          sx={{ p: 0, backgroundColor: "transparent !important" }}
        >
          <Close fontSize="small" />
        </IconButton>
      ) : (
        <IconButton
          disableRipple
          disableFocusRipple
          onClick={() => {
            saveSettings({ ...settings, navCollapsed: !navCollapsed });
          }}
          sx={{
            p: 0,
            color: "text.primary",
            backgroundColor: "transparent !important",
          }}
        >
          <Box
            width={22}
            fill="none"
            height={22}
            component="svg"
            viewBox="0 0 22 22"
            xmlns="http://www.w3.org/2000/svg"
            sx={{
              transform: `rotate(${svgRotationDeg()}deg)`,
              transition: "transform .30s ease-in-out .35s",
            }}
          >
            <path
              fill={theme.palette.text.secondary}
              d="M11.4854 4.88844C11.0082 4.41121 10.2344 4.41121 9.75716 4.88844L4.51029 10.1353C4.03299 10.6126 4.03299 11.3865 4.51029 11.8638L9.75716 17.1107C10.2344 17.5879 11.0082 17.5879 11.4854 17.1107C11.9626 16.6334 11.9626 15.8597 11.4854 15.3824L7.96674 11.8638C7.48943 11.3865 7.48943 10.6126 7.96674 10.1353L11.4854 6.61667C11.9626 6.13943 11.9626 5.36568 11.4854 4.88844Z"
            />
            <path
              fill={theme.palette.text.disabled}
              d="M15.8683 4.88844L10.6214 10.1353C10.1441 10.6126 10.1441 11.3865 10.6214 11.8638L15.8683 17.1107C16.3455 17.5879 17.1193 17.5879 17.5965 17.1107C18.0737 16.6334 18.0737 15.8597 17.5965 15.3824L14.0779 11.8638C13.6005 11.3865 13.6005 10.6126 14.0779 10.1353L17.5965 6.61667C18.0737 6.13943 18.0737 5.36568 17.5965 4.88844C17.1193 4.41121 16.3455 4.41121 15.8683 4.88844Z"
            />
          </Box>
        </IconButton>
      )}
    </MenuHeaderWrapper>
  );
};

export default SideMenuHeader;
